import { Box, Button, Divider } from "@mui/material";
import { CalcTypeText } from "../../../../types/budget/budget";
import { toast } from "react-toastify";
import BudgetTotals from "../ServiceTotals";
import { useServices } from "../../../../contexts/ServicesContext/projectservices.context";
import ServiceSupplier from "../ServiceSupplier";

export function RenderServiceInfo() {
  const {
    activeService,
    loadingService,
    createEmptyService,
    activeServiceDispatch,
    activeCalcOption,
    updateService,
    categoriesSnapshot,
  } = useServices();

  const supplierList = () => {
    return activeService?.supplierList?.map((el, index) => {
      if (el.calcOption === activeCalcOption)
        return (
          <ServiceSupplier
            supplierId={el.supplierId}
            key={el.supplierId + index}
            index={index}
            calcOption={activeCalcOption}
          />
        );
      else return <></>;
    });
  };

  return activeCalcOption !== "budgetTotals" ? (
    <Box width={"100%"}>
      <Box pb={2}>
        {/* <Box gap={2} p={1}>
          <span>{CalcTypeText[activeCalcOption]}</span>
          <Divider sx={{ p: 1 }} />
        </Box> */}
        <span style={{ fontSize: "20px", fontWeight: "semi-bold" }}>
          {activeService.name || `Serviço`} &nbsp;
        </span>
      </Box>
      {supplierList()}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-end",
          marginTop: "5px",
        }}
      >
        <Button
          onClick={() => {
            activeServiceDispatch({
              type: "ADD_SUPPLIER",
              payload: { calcOption: activeCalcOption },
            });
          }}
          sx={{
            fontSize: "14px",
            mt: 2,
            px: 1,
          }}
          variant="outlined"
          size="small"
          disabled={false}
        >
          Novo fornecedor
        </Button>

        <Button
          sx={{
            fontSize: "14px",
            mt: 2,
            px: 1,
          }}
          size="small"
          onClick={() => {
            const hasUndefinedCategories = categoriesSnapshot?.some((el) => {
              const serviceActive: any = activeService;
              const value =
                serviceActive?.itemTypeList?.[activeCalcOption]?.[el.value];
              return value === undefined || value === null;
            });

            if (hasUndefinedCategories) {
              return toast.error(
                <div style={{ whiteSpace: "pre-line" }}>
                  {`Existem categorias sem definição (S/N)
                    Na lista de Categorias, marque S ou N para cada categoria`}
                </div>
              );
            }

            if (activeService._id)
              updateService(activeService._id, activeService, "SAVE", -1);
            toast.success("Alterações salvas.");
          }}
          disabled={false}
        >
          Salvar
        </Button>
      </Box>
    </Box>
  ) : (
    <BudgetTotals />
  );
}
